<template>
    <div class="header" :class="isCollapse ? '' : 'fixed'">
    </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped>
</style>